module.exports = __webpack_public_path__ + "static/media/01_twitter_image.e2c88944.jpg";